<template>
  <div v-loading="loading" class="full">
    <w-flow-map-title :rscPerfData="rscPerfData" :objtypeId="selectedNode.obj.objtypeId" />
      <div class="default-layout type02-layout">
      <div class="col row-half">
        <w-flow-map-user-process :rsc-perf-data="rscPerfData" :objtype-id="selectedNode.obj.objtypeId" />
        <w-flow-map-system-tab :systemTabData="rscPerfData">
          <!-- arrow -->
          <w-flow-map-flow-field
          slot="sysFlowFiled"
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_BATCH_REQUEST_COUNT"
          label="배치요청"
          :arrow-settings="{ top: '50px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
        </w-flow-map-system-tab>
      </div>

      <div class="col row-full">
        <div class="flowmap-box small" style="width: 180px;">
          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          label="송신량"
          perfKey="SYSSTAT/DB_CLIENT_SENDSIZE"
          :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->

          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_WRITE_COUNT"
          label="쓰기"
          :arrow-settings="{ top: '100px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow -->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_COMPILATIONS_COUNT"
          label="편집"
          :arrow-settings="{ top: '451px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->

          <div class="flowmap-header">
            SQL Process
          </div>
          <div class="flowmap-content">
            <ul class="flowmap-center is-border">
              <li>
                <span>Total</span>
                <strong>{{rscPerfData['MS_SQLPROC/DBMS_SQL_PROCESS_TOTAL_COUNT']}}</strong>
              </li>
              <li>
                <span>System</span>
                <strong>{{rscPerfData['MS_SQLPROC/DBMS_SQL_PROCESS_SYSTEM_COUNT']}}</strong>
              </li>
              <li>
                <span>User</span>
                <strong>{{rscPerfData['MS_SQLPROC/DBMS_SQL_PROCESS_USER_COUNT']}}</strong>
              </li>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="LOCK/DB_LOCK_USERATE" :isValue="false" label="Lock 사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="LOCK/DB_LOCK_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <li>
                <div class="radius-bx">
                  <span>Alert Msg View</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col row-full">
        <div class="flowmap-box" style="width: 240px;">
          <!-- arrow Read-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_READ_COUNT"
          label="읽기"
          :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow writes-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_PAGE_WRITES_COUNT"
          label="페이지 쓰기"
          :arrow-settings="{ top: '66px', arrowDirection: 'arrow-right', arrowSize: 'large large-a'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow checkPoint-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_CHECKPOINT_PAGES_COUNT"
          label="Check Point"
          :arrow-settings="{ top: '240px', arrowDirection: 'arrow-right', arrowSize: 'medium'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow LOG FLush-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_LOG_FLUSHES_COUNT"
          label="Log Flush"
          :arrow-settings="{ top: '370px', arrowDirection: 'arrow-right', arrowSize: 'large large-a'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <div class="flowmap-header thema-dark">
              SQL Memory
            </div>
            <div class="flowmap-content">
              <ul class="flowmap-list is-border">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_MEM_TOTAL_SIZE" label="전체크기"></w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_MEM_USEDRATE" :isValue="false" label="사용률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_MEM_USEDRATE"></w-flow-map-progressbar>
                </w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_MEM_USEDSIZE" label="사용량"></w-flow-map-item-label>
              </ul>

              <ul class="flowmap-list is-border">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_BUF_CACHE_TOTAL_SIZE" label="Buffer Cache Size"></w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_BUF_CACHE_USERATE" :isValue="false" label="사용률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_BUF_CACHE_USERATE"></w-flow-map-progressbar>
                </w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_BUF_CACHE_USEDSIZE" label="사용량"></w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO" :isValue="false" label="적중률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO"></w-flow-map-progressbar>
                </w-flow-map-item-label>
              </ul>

              <ul class="flowmap-list is-border">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_TOTAL_SIZE" label="Procedure Cache Size"></w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_USERATE" :isValue="false" label="사용률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_USERATE"></w-flow-map-progressbar>
                </w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_USEDSIZE" label="사용량"></w-flow-map-item-label>
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_HITRATIO" :isValue="false" label="적중률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_PROCEDURE_CACHE_HITRATIO"></w-flow-map-progressbar>
                </w-flow-map-item-label>
              </ul>
              <ul class="flowmap-list is-border">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_LOG_CACHE_HITRATIO" :isValue="false" label="Log Cache 적중률">
                  <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_MEMSTAT/DBMS_LOG_CACHE_HITRATIO"></w-flow-map-progressbar>
                </w-flow-map-item-label>
              </ul>
            </div>
        </div>
      </div>

      <div class="col row-top-space02 undercover">
        <div class="flowmap-box medium">
          <div class="flowmap-header thema-dark">
            BG Process
          </div>
          <div class="flowmap-content">
            <div class="flowmap-content-header">
              <ul class="flowmap-list">
                <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="PROC/DB_PROC_TOTAL_COUNT" label="Total"></w-flow-map-item-label>
              </ul>
            </div>

            <ul class="flowmap-list is-border">
              <li>
                <div class="radius-bx">
                  <span>Check Point</span>
                </div>
              </li>
            </ul>
            <ul class="flowmap-list is-border">
              <li>
                <div class="radius-bx">
                  <span>Log Writer</span>
                </div>
              </li>
            </ul>
            <ul class="flowmap-list is-border">
              <li>
                <div class="radius-bx">
                  <span>Lazy Writer</span>
                </div>
              </li>
            </ul>
            <ul class="flowmap-list is-border">
              <li>
                <div class="radius-bx">
                  <span>Lock Monitor</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col row-full">
        <div class="flowmap-box" style="width: 270px;">
          <!-- arrow 페이지 읽기-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_PAGE_READES_COUNT"
          label="페이지 읽기"
          :arrow-settings="{ top: '25px', arrowDirection: 'arrow-left', arrowSize: 'large large-a'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <!-- arrow 페이지 ahead-->
          <w-flow-map-flow-field
          :perfRecords="rscPerfData"
          perfKey="MS_SYSSTAT/DBMS_READAHEAD_PAGES_COUNT"
          label="페이지 ahead"
          :arrow-settings="{ top: '107px', arrowDirection: 'arrow-left', arrowSize: 'large large-a'}">
          </w-flow-map-flow-field>
          <!-- arrow -->
          <div class="flowmap-header thema-dark">
            Disk Storage
          </div>
          <div class="flowmap-content">
            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye"></i> <strong>DB Database Files</strong></li>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_USERATE" :isValue="false" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_SIZE" label="전체크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_USESIZE" label="사용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_COUNT" label="DataBase 수"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_DATAFILE_GROUPS" label="파일 그룹 수"></w-flow-map-item-label>
            </ul>

            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye"></i> <strong>DB Redo Logs</strong></li>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_LOGFILE_USERATE" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_LOGFILE_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_LOGFILE_SIZE" label="전체크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_LOGFILE_USEDSIZE" label="사용량"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MS_TABLESPACE/DBMS_TABLESPACE_LOGFILE_COUNT" label="파일 수"></w-flow-map-item-label>
            </ul>

            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye"></i> <strong>Log File System</strong></li>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_USERATE" :isValue="false" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="DISK/DISK_USERATE"></w-flow-map-progressbar>
              </w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_TOTSIZE" label="전체크기"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DISK/DISK_USEDSIZE" label="사용량"></w-flow-map-item-label>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import FlowMapAPI from '@/api/performance/database/flow-map';
import WFlowMapSystemTab from '@/views/performance/node/database-flow-map/components/FlowMapSystemTab';
import WFlowMapTitle from '@/views/performance/node/database-flow-map/components/FlowMapTitle';
import WFlowMapUserProcess from '@/views/performance/node/database-flow-map/components/FlowMapUserProcess';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import WFlowMapItemLabel from './components/FlowMapItemLabel';
import WFlowMapFlowField from './components/FlowMapFlowField';
import WFlowMapProgressbar from './components/FlowMapProgressbar';

export default {
  name: 'WMsSqlFlowMap',
  props: {
    active: Boolean,
    selectedNode: {
      type: Object,
    },
  },
  components: {
    WFlowMapSystemTab,
    WRscPerfEventProgressBar,
    WFlowMapFlowField,
    WFlowMapTitle,
    WFlowMapUserProcess,
    WFlowMapItemLabel,
    WFlowMapProgressbar,
  },
  data() {
    return {
      loading: false,
      rscPerfData: {},
    };
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        if (!this.active) {
          return;
        }
        // handler (to, from)
        // 선택된 DB가 변경될 때 수행해야할 로직 작성.
        this.loadData();
      },
    },
    /**
     * [Flow 맵] 탭 활성화 시 재로드
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        objtypeId: this.selectedNode.obj.objtypeId,
      };
      this.loading = true;
      FlowMapAPI.getRscPerfAndEventOfDatabase(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.rscPerfData = response.data.data[0];
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/MsSqlFlowMap.vue